import { createSlice } from "@reduxjs/toolkit";

const pollCreationSlice = createSlice({
    name: "pollCreationReducer",
    initialState: {
        pollTitleFilterLoading: false,
        pollTitleFilterData: null,
        pollTitleFilterError: null,

        pollStatusFilterLoading: false,
        pollStatusFilterData: null,
        pollStatusFilterError: null,

        pollDeviceFilterLoading: false,
        pollDeviceFilterData: null,
        pollDeviceFilterError: null,

        pollPageTypeFilterLoading: false,
        pollPageTypeFilterData: null,
        pollPageTypeFilterError: null,

        pollEntityTypeFilterLoading: false,
        pollEntityTypeFilterData: null,
        pollEntityTypeFilterError: null,

        pollEntityNameFilterLoading: false,
        pollEntityNameFilterData: null,
        pollEntityNameFilterError: null,

        pollsListLoading: false,
        pollsListData: null,
        pollsListError: null,

        postPollsLoading: false,
        postPollsData: null,
        postPollsError: null,

        putPollsLoading: false,
        putPollData: null,
        putPollError: null,

        pollDomainTypeLoading: false,
        pollDomainTypeData: null,
        pollDomainTypeError: null,

        pollSubPageLoading: false,
        pollSubPageData: null,
        pollSubPageError: null,

        getPollsLoading: false,
        getPollsData: null,
        getPollsError: null,

        deletePollsLoading: false,
        deletePollsData: null,
        deletePollsError: null,

        message:null,

    },
    reducers: {

        getPollTitleFilterLoading(state, action) {
            return {
                ...state,
                pollTitleFilterLoading: true,
            };
        },
        getPollTitleFilterSuccess(state, action) {
            return {
                ...state,
                pollTitleFilterLoading: false,
                pollTitleFilterData: action.payload,
            };
        },
        getPollTitleFilterFailure(state, action) {
            return {
                ...state,
                pollTitleFilterLoading: false,
                pollTitleFilterError: action.payload,
            };
        },

        getPollStatusFilterLoading(state, action) {
            return {
                ...state,
                pollStatusFilterLoading: true,
            };
        },
        getPollStatusFilterSuccess(state, action) {
            return {
                ...state,
                pollStatusFilterLoading: false,
                pollStatusFilterData: action.payload,
            };
        },
        getPollStatusFilterFailure(state, action) {
            return {
                ...state,
                pollStatusFilterLoading: false,
                pollStatusFilterError: action.payload,
            };
        },

        getPollDeviceFilterLoading(state, action) {
            return {
                ...state,
                pollDeviceFilterLoading: true,
            };
        },
        getPollDeviceFilterSuccess(state, action) {
            return {
                ...state,
                pollDeviceFilterLoading: false,
                pollDeviceFilterData: action.payload,
            };
        },
        getPollDeviceFilterFailure(state, action) {
            return {
                ...state,
                pollDeviceFilterLoading: false,
                pollDeviceFilterError: action.payload,
            };
        },

        getPollPageTypeFilterLoading(state, action) {
            return {
                ...state,
                pollPageTypeFilterLoading: true,
            };
        },
        getPollPageTypeFilterSuccess(state, action) {
            return {
                ...state,
                pollPageTypeFilterLoading: false,
                pollPageTypeFilterData: action.payload,
            };
        },
        getPollPageTypeFilterFailure(state, action) {
            return {
                ...state,
                pollPageTypeFilterLoading: false,
                pollPageTypeFilterError: action.payload,
            };
        },

        getPollEntityTypeFilterLoading(state, action) {
            return {
                ...state,
                pollEntityTypeFilterLoading: true,
            };
        },
        getPollEntityTypeFilterSuccess(state, action) {
            return {
                ...state,
                pollEntityTypeFilterLoading: false,
                pollEntityTypeFilterData: action.payload,
            };
        },
        getPollEntityTypeFilterFailure(state, action) {
            return {
                ...state,
                pollEntityTypeFilterLoading: false,
                pollEntityTypeFilterError: action.payload,
            };
        },

        getPollEntityNameFilterLoading(state, action) {
            return {
                ...state,
                pollEntityNameFilterLoading: true,
            };
        },
        getPollEntityNameFilterSuccess(state, action) {
            return {
                ...state,
                pollEntityNameFilterLoading: false,
                pollEntityNameFilterData: action.payload,
            };
        },
        getPollEntityNameFilterFailure(state, action) {
            return {
                ...state,
                pollEntityNameFilterLoading: false,
                pollEntityNameFilterError: action.payload,
            };
        },

        getPollsListLoading(state, action) {
            return {
                ...state,
                pollsListLoading: true,
            };
        },
        getPollsListSuccess(state, action) {
            return {
                ...state,
                pollsListLoading: false,
                pollsListData: action.payload,
            };
        },
        getPollsListFailure(state, action) {
            return {
                ...state,
                pollsListLoading: false,
                pollsListError: action.payload,
            };
        },

        postPollLoading(state, action) {
            return {
                ...state,
                postPollsLoading: true,
            };
        },
        postPollsSuccess(state, action) {
            return {
                ...state,
                postPollsLoading: false,
                postPollsData: action.payload,
                message: action.payload,
            };
        },
        postPollsFailure(state, action) {
            return {
                ...state,
                postPollsLoading: false,
                postPollsError: action.payload,
                message: action.payload,
            };
        },

        putPollsLoading(state, action) {
            return {
                ...state,
                putPollsLoading: true,
            };
        },
        putPollsSuccess(state, action) {
            return {
                ...state,
                putPollsLoading: false,
                putPollData: action.payload,
                message: action.payload,
            };
        },
        putPollsFailure(state, action) {
            return {
                ...state,
                putPollsLoading: false,
                putPollError: action.payload,
                message: action.payload,
            };
        },

        getPollDomainTypeLoading(state, action) {
            return {
                ...state,
                pollDomainTypeLoading: true,
            };
        },

        getPollDomainTypeSuccess(state, action) {
            return {
                ...state,
                pollDomainTypeLoading: false,
                pollDomainTypeData: action.payload.domain,
            };
        },

        getPollDomainTypeFailure(state, action) {
            return {
                ...state,
                pollDomainTypeLoading: false,
                pollDomainTypeData: action.payload,
            }
        },

        getPollSubPageLoading(state, action) {
            return {
                ...state,
                pollSubPageLoading: true,
            };
        },

        getPollSubPageSuccess(state, action) {
            return {
                ...state,
                pollSubPageLoading: false,
                pollSubPageData: action.payload,
            };
        },

        getPollSubPageFailure(state, action) {
            return {
                ...state,
                pollSubPageLoading: false,
                pollSubPageError: action.payload,
            };
        },

        getPollsDataLoading(state, action) {
            return {
                ...state,
                getPollsLoading: true,
            };
        },

        getPollsDataSuccess(state, action) {
            return {
                ...state,
                getPollsLoading: false,
                getPollsData: action.payload,
            };
        },

        getPollsDataFailure(state, action) {
            return {
                ...state,
                getPollsLoading: false,
                getPollsError: action.payload,
            };
        },

         deletePollsDataLoading(state, action) {
            return {
                ...state,
                deletePollsLoading: true,
            };
        },

         deletePollsDataSuccess(state, action) {
            return {
                ...state,
                deletePollsLoading: false,
                deletePollsData: action.payload,
                message: action.payload,
            };
        },

         deletePollsDataFailure(state, action) {
            return {
                ...state,
                deletePollsLoading: false,
                deletePollsError: action.payload,
                message: action.payload,
            };
        },

        // to clear message
        clearMessage(state, action) {
            return {
                ...state,
                message:null,
                deletePollsError:null,
                putPollError:null,
                postPollsError:null,
                postPollsData:null,
                putPollData:null,
                deletePollsData:null,
            };
        },
         // to clear message
         clearDropDowndata(state, action) {
            return {
                ...state,
                pollEntityTypeFilterData:null,
                pollEntityNameFilterData:null,
                pollSubPageData:null,
            };
        },



    },
});
export const {
    getPollTitleFilterLoading,
    getPollTitleFilterSuccess,
    getPollTitleFilterFailure,

    getPollStatusFilterLoading,
    getPollStatusFilterSuccess,
    getPollStatusFilterFailure,

    getPollDeviceFilterLoading,
    getPollDeviceFilterSuccess,
    getPollDeviceFilterFailure,

    getPollPageTypeFilterLoading,
    getPollPageTypeFilterSuccess,
    getPollPageTypeFilterFailure,

    getPollEntityTypeFilterLoading,
    getPollEntityTypeFilterSuccess,
    getPollEntityTypeFilterFailure,

    getPollEntityNameFilterLoading,
    getPollEntityNameFilterSuccess,
    getPollEntityNameFilterFailure,

    getPollsListLoading,
    getPollsListSuccess,
    getPollsListFailure,

    postPollLoading,
    postPollsSuccess,
    postPollsFailure,

    putPollsLoading,
    putPollsSuccess,
    putPollsFailure,

    getPollDomainTypeLoading,
    getPollDomainTypeSuccess,
    getPollDomainTypeFailure,

    getPollSubPageLoading,
    getPollSubPageSuccess,
    getPollSubPageFailure,

    getPollsDataLoading,
    getPollsDataSuccess,
    getPollsDataFailure,

    deletePollsDataLoading,
    deletePollsDataSuccess,
    deletePollsDataFailure,

    clearMessage,
    clearDropDowndata,

} = pollCreationSlice.actions;

export default pollCreationSlice.reducer;